// §4.4 partial — admin/marketing route set.
// Covers: /admin/marketing, /admin/marketing/funnel, /admin/marketing/segments,
//         /admin/campaigns, /admin/campaigns/owned, /admin/campaigns/utms,
//         /admin/utms, /admin/utm-registry, /admin/utm-registry/:rowId
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const MarketingDashboardPage = lazyWithRetry(
  () => import("./pages/MarketingDashboardPage"),
);
const MarketingFunnelPage = lazyWithRetry(
  () => import("./pages/MarketingFunnelPage"),
);
const MarketingSegmentsPage = lazyWithRetry(
  () => import("./pages/MarketingSegmentsPage"),
);
const UtmRegistryPage = lazyWithRetry(() => import("./pages/UtmRegistryPage"));
const UtmRegistryDetailPage = lazyWithRetry(
  () => import("./pages/UtmRegistryDetailPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/marketing", Component: MarketingDashboardPage },
      { path: "/admin/marketing/funnel", Component: MarketingFunnelPage },
      { path: "/admin/marketing/segments", Component: MarketingSegmentsPage },
      { path: "/admin/campaigns", Component: MarketingDashboardPage },
      { path: "/admin/campaigns/owned", Component: MarketingDashboardPage },
      { path: "/admin/campaigns/utms", Component: MarketingDashboardPage },
      { path: "/admin/utms", Component: MarketingDashboardPage },
      { path: "/admin/utm-registry", Component: UtmRegistryPage },
      { path: "/admin/utm-registry/:rowId", Component: UtmRegistryDetailPage },
    ],
  },
];

export default routes;
